import '../../css/pages/common.less'
import '../../css/pages/common_1.less'
import '../../css/pages/common_10.less'
import '../../css/pages/common_13.less'
import '../../css/pages/common_15.less'
import '../../css/pages/common_2.less'
import '../../css/pages/common_6.less'
import '../../css/pages/common_8.less'
import '../../css/pages/common_9.less'
import '../../css/pages/common_10.less'
import '../../css/pages/common_4.less'
import '../../css/pages/common_17.less'
//接口
require('./api')
require('../common/mam-timecode-convert.min.js')
require('../common/timeCode.js')
//部分组件传参会有问题，使用script标签方式引入
// import $ from 'jquery'
// window.$ = $
// import ElementUI from 'element-ui'
// import Vue from 'vue/dist/vue.esm.js'
// window.Vue = Vue
// Vue.use(ElementUI)
// Vue.prototype.$ = $

import { FooterComponent, HeaderComponent } from '../header/bundle/index.umd'
if (window.bannerPlateType == 6) {
  setTimeout(() => {
    API.reqUserTokenInfo().then(res => {
      let token
      if (res.errorCode == 'success') {
        token = res.extendMessage?.extend?.jwt
      }
      document.querySelector('#head_container') && HeaderComponent('#head_container', token || '')
      document.querySelector('#foot_container') && FooterComponent('#foot_container')
    })
  }, 100);
}

require('./utils/global_util')

//播放器插件
require('./utils/player_utils')

/**
 * vue全局组件
 */
//百纳秒转秒
require('./filters/filter')
//校内认证开关控制
require('./directives/certification_show')
//全局mixin
require('./mixins/base_mixin')
//文件类型图标
require('./components/file_type_icon')
//iconfont
require('./components/iconfont')
//课程笔记组件
require('./components/course_note_panel')
//课程笔记组件
require('./components/course_note_panel_new')
//问答
require('./components/question_answer_panel')
require('./components/question_answer_item')
require('./components/question_detail')
require('./components/public_qa_modal')
//评论
require('./components/comment_item')
require('./components/course_overview_panel')
require('./components/notice_card')
//直播卡片
require('./components/live_card')
// 评论显示组件
require('./components/comment_list')
// 文本多行展开收起组件
require('./components/text-clamp')
// 文本多行展开收起组件
require('./components/auto_text_clamp')
// 语音文本
require('./components/voice-list')
//公用图片
require('./components/base_image')
// 课程图片列表
require('./components/course_picture_panel')
// 批量设置公开画面
require('./components/public_frame_modal')
//线下课程信息
require('./components/offline_list_modal')
//直播互动
require('./components/live_interaction')
// 资源库下载弹框
require('./components/resource_download_modal')
//资源分享弹框
require('./components/resource_share_modal')
//资源复制弹框
require('./components/resource_copy_modal')
//知识点弹框
require('./components/knowledge_point_modal')
//课程封面
require('./components/course_cover')
//视频弹题
require('./components/video_question_modal')
//收藏点赞
require('./components/collect_and_like')
//gpt关键词解析
require('./components/keyword_analysis')
//课件截图
require('./components/courseware_screenshoot_panel')
//以图搜图
require('./components/search_by_picture_modal.js')
//以图搜图上传弹框
require('./components/upload_picture_modal.js')
//课件截图
require('./components/course_ppt_panel')
//分享按钮
require('./components/share_popover_btn')
//课程学习要求弹框
require('./components/necessary_modal')
//必学标签
require('./components/necessary_tag')
//我的笔记
require('./components/my_note_panel')
//我的笔记内容
require('./components/my_note_content')

//自适应菜单栏
require('./utils/auto_menu_display')
//pc端涨知识card
require('./components/knowledge_course_card/index.js')
//模块访问统计
require('./utils/module_access_statistics')
//免责声明弹框
require('./components/disclaimer_modal')
//直播语音转写
require('./components/voice_translate')
//输入框语音转写
require('./components/voice_to_text')
//资源问答
require('./components/resource_qa_panel')
//重写全局empty组件
require('./components/empty')
//词云
require('./components/word_cloud_panel')
//知识要点
require('./components/knowledge_essentials_panel')


import enums from './utils/enums.js'
window.app.enums = enums
